import { useState } from "react";
import { http, fmtErr } from "@/lib/api";
import { toast } from "sonner";

export default function PropertyContactSettings({ prop }) {
  const [email, setEmail] = useState(prop?.email || "");
  const [mapsUrl, setMapsUrl] = useState(prop?.google_maps_url || "");
  const [dirEnabled, setDirEnabled] = useState(prop?.get_directions_enabled !== false);

  const save = async (patch) => {
    try {
      await http.put("/admin/property", patch);
      toast.success("Saved");
    } catch (e) { toast.error(fmtErr(e)); }
  };

  return (
    <>
      <div className="card" data-testid="contact-email-settings">
        <h3 className="font-serif text-2xl mb-1">Property Contact Email</h3>
        <p className="text-xs mb-3" style={{ color: "var(--muted)" }}>
          Shown on the public Contact page and used for guest communication. This does NOT change your login email.
        </p>
        <input data-testid="contact-email-input" type="email" value={email} className="mb-3"
          placeholder="contact@freebirdsnest.com" onChange={(e) => setEmail(e.target.value)} />
        <button data-testid="contact-email-save" className="btn-primary" onClick={() => save({ email })}>Save Contact Email</button>
      </div>

      <div className="card" data-testid="maps-settings">
        <h3 className="font-serif text-2xl mb-1">Google Maps / Get Directions</h3>
        <p className="text-xs mb-3" style={{ color: "var(--muted)" }}>
          The public website's "Get Directions" button opens this exact link in a new tab.
        </p>
        <label className="flex items-center gap-3 mb-4 text-sm cursor-pointer">
          <input type="checkbox" style={{ width: "auto" }} data-testid="maps-enabled" checked={dirEnabled}
            onChange={(e) => { setDirEnabled(e.target.checked); save({ get_directions_enabled: e.target.checked }); }} />
          Enable "Get Directions" button
        </label>
        <label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>Google Maps URL</label>
        <input data-testid="maps-url" value={mapsUrl} className="mb-3" placeholder="https://maps.google.com/…"
          onChange={(e) => setMapsUrl(e.target.value)} />
        <button data-testid="maps-save" className="btn-primary" onClick={() => save({ google_maps_url: mapsUrl })}>Save Maps URL</button>
      </div>
    </>
  );
}
